// extracted by mini-css-extract-plugin
module.exports = {"container":"CartItem_container__GgkFI","thumbnail":"CartItem_thumbnail__9iJUC"};